module.exports = __webpack_public_path__ + "60c1749f9ff42506691acd68cfc1c19b.woff";